import { useAtomValue, useSetAtom } from 'jotai';

import { initialDistinctIdAtom } from '$src/business/atoms/initial-distinct-id';

export function useInitialDistinctIdRO() {
  return useAtomValue(initialDistinctIdAtom);
}

export function useSetInitialDistinctId() {
  return useSetAtom(initialDistinctIdAtom);
}
